export const TerminalIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-400H160v400Zm187-200-76-76q-12-12-11.5-28t12.5-28q12-11 28-11.5t28 11.5l104 104q12 12 12 28t-12 28L328-308q-11 11-27.5 11.5T272-308q-11-11-11-28t11-28l75-76Zm173 160q-17 0-28.5-11.5T480-320q0-17 11.5-28.5T520-360h160q17 0 28.5 11.5T720-320q0 17-11.5 28.5T680-280H520Z" />
  </svg>
);

export const TransferIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path d="M727-240H600q-17 0-28.5-11.5T560-280q0-17 11.5-28.5T600-320h127l-35-35q-11-12-11.5-28.5T692-412q12-12 28-12t28 12l104 104q12 12 12 28t-12 28L748-148q-12 12-28 12t-28-12q-12-12-11.5-28.5T692-205l35-35Zm-487 0-86 86q-10 10-22 5t-12-19v-552q0-33 23.5-56.5T200-800h480q33 0 56.5 23.5T760-720v160q0 17-11.5 28.5T720-520q-17 0-28.5-11.5T680-560v-160H200v400h240q17 0 28.5 11.5T480-280q0 17-11.5 28.5T440-240H240Zm80-320h240q17 0 28.5-11.5T600-600q0-17-11.5-28.5T560-640H320q-17 0-28.5 11.5T280-600q0 17 11.5 28.5T320-560Zm0 160h120q17 0 28.5-11.5T480-440q0-17-11.5-28.5T440-480H320q-17 0-28.5 11.5T280-440q0 17 11.5 28.5T320-400Zm-120 80v-400 400Z" />
  </svg>
);

export const ConfigIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm224-124q11 8 21.5 13.5T428-340l6 29q3 14 13.5 22.5T472-280h16q14 0 24.5-9t13.5-23l6-28q12-5 22.5-10.5T576-364l29 9q13 4 25.5-1t19.5-16l8-14q7-12 5-26t-13-23l-22-19q2-13 2-26t-2-26l22-19q11-9 13-22.5t-5-25.5l-9-15q-7-11-19-16t-25-1l-29 9q-11-8-21.5-13.5T532-620l-6-29q-3-14-13.5-22.5T488-680h-16q-14 0-24.5 9T434-648l-6 28q-12 5-22.5 10.5T384-596l-29-9q-13-4-25.5 1T310-588l-8 14q-7 12-5 26t13 23l22 19q-2 13-2 26t2 26l-22 19q-11 9-13 22.5t5 25.5l9 15q7 11 19 16t25 1l29-9Zm96-36q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400ZM160-240v-480 480Z" />
  </svg>
);

export const CloseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path d="M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z" />
  </svg>
);

export const TagsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path d="M856-390 570-104q-12 12-27 18t-30 6q-15 0-30-6t-27-18L103-457q-11-11-17-25.5T80-513v-287q0-33 23.5-56.5T160-880h287q16 0 31 6.5t26 17.5l352 353q12 12 17.5 27t5.5 30q0 15-5.5 29.5T856-390ZM513-160l286-286-353-354H160v286l353 354ZM260-640q25 0 42.5-17.5T320-700q0-25-17.5-42.5T260-760q-25 0-42.5 17.5T200-700q0 25 17.5 42.5T260-640Zm220 160Z" />
  </svg>
);

export const threeDotsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path d="M240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400Z" />
  </svg>
);

export const SuccessBadgeIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6414_14930)">
      <circle cx="7" cy="7" r="7" fill="white" />
      <path
        d="M6.18341 9.68333L10.2959 5.57083L9.47925 4.75417L6.18341 8.05L4.52091 6.3875L3.70425 7.20417L6.18341 9.68333ZM7.00008 12.8333C6.19314 12.8333 5.4348 12.6802 4.72508 12.374C4.01536 12.0677 3.398 11.6521 2.873 11.1271C2.348 10.6021 1.93237 9.98472 1.62612 9.275C1.31987 8.56528 1.16675 7.80694 1.16675 7C1.16675 6.19306 1.31987 5.43472 1.62612 4.725C1.93237 4.01528 2.348 3.39792 2.873 2.87292C3.398 2.34792 4.01536 1.93229 4.72508 1.62604C5.4348 1.31979 6.19314 1.16667 7.00008 1.16667C7.80703 1.16667 8.56536 1.31979 9.27508 1.62604C9.9848 1.93229 10.6022 2.34792 11.1272 2.87292C11.6522 3.39792 12.0678 4.01528 12.374 4.725C12.6803 5.43472 12.8334 6.19306 12.8334 7C12.8334 7.80694 12.6803 8.56528 12.374 9.275C12.0678 9.98472 11.6522 10.6021 11.1272 11.1271C10.6022 11.6521 9.9848 12.0677 9.27508 12.374C8.56536 12.6802 7.80703 12.8333 7.00008 12.8333ZM7.00008 11.6667C8.30286 11.6667 9.40633 11.2146 10.3105 10.3104C11.2147 9.40625 11.6667 8.30278 11.6667 7C11.6667 5.69722 11.2147 4.59375 10.3105 3.68958C9.40633 2.78542 8.30286 2.33333 7.00008 2.33333C5.6973 2.33333 4.59383 2.78542 3.68966 3.68958C2.7855 4.59375 2.33341 5.69722 2.33341 7C2.33341 8.30278 2.7855 9.40625 3.68966 10.3104C4.59383 11.2146 5.6973 11.6667 7.00008 11.6667Z"
        fill="#86CB7B"
      />
    </g>
    <defs>
      <clipPath id="clip0_6414_14930">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FailureBadgeIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6414_15790)">
      <circle cx="7" cy="7" r="7" fill="white" />
      <path
        d="M4.90008 9.91663L7.00008 7.81663L9.10008 9.91663L9.91675 9.09996L7.81675 6.99996L9.91675 4.89996L9.10008 4.08329L7.00008 6.18329L4.90008 4.08329L4.08341 4.89996L6.18341 6.99996L4.08341 9.09996L4.90008 9.91663ZM7.00008 12.8333C6.19314 12.8333 5.4348 12.6802 4.72508 12.3739C4.01536 12.0677 3.398 11.652 2.873 11.127C2.348 10.602 1.93237 9.98468 1.62612 9.27496C1.31987 8.56524 1.16675 7.8069 1.16675 6.99996C1.16675 6.19302 1.31987 5.43468 1.62612 4.72496C1.93237 4.01524 2.348 3.39788 2.873 2.87288C3.398 2.34788 4.01536 1.93225 4.72508 1.626C5.4348 1.31975 6.19314 1.16663 7.00008 1.16663C7.80703 1.16663 8.56536 1.31975 9.27508 1.626C9.9848 1.93225 10.6022 2.34788 11.1272 2.87288C11.6522 3.39788 12.0678 4.01524 12.374 4.72496C12.6803 5.43468 12.8334 6.19302 12.8334 6.99996C12.8334 7.8069 12.6803 8.56524 12.374 9.27496C12.0678 9.98468 11.6522 10.602 11.1272 11.127C10.6022 11.652 9.9848 12.0677 9.27508 12.3739C8.56536 12.6802 7.80703 12.8333 7.00008 12.8333ZM7.00008 11.6666C8.30286 11.6666 9.40633 11.2145 10.3105 10.3104C11.2147 9.40621 11.6667 8.30274 11.6667 6.99996C11.6667 5.69718 11.2147 4.59371 10.3105 3.68954C9.40633 2.78538 8.30286 2.33329 7.00008 2.33329C5.6973 2.33329 4.59383 2.78538 3.68966 3.68954C2.7855 4.59371 2.33341 5.69718 2.33341 6.99996C2.33341 8.30274 2.7855 9.40621 3.68966 10.3104C4.59383 11.2145 5.6973 11.6666 7.00008 11.6666Z"
        fill="#F27468"
      />
    </g>
    <defs>
      <clipPath id="clip0_6414_15790">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CopyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M379.78-233.78q-41 0-69.5-28.5t-28.5-69.5v-466.44q0-41 28.5-69.5t69.5-28.5h370.44q41 0 69.5 28.5t28.5 69.5v466.44q0 41-28.5 69.5t-69.5 28.5H379.78Zm0-98h370.44v-466.44H379.78v466.44Zm-170 268q-41 0-69.5-28.5t-28.5-69.5v-515.44q0-20.38 14.25-34.69 14.24-14.31 34.54-14.31 20.3 0 34.76 14.31 14.45 14.31 14.45 34.69v515.44h419.44q20.38 0 34.69 14.24 14.31 14.25 14.31 34.55 0 20.3-14.31 34.75-14.31 14.46-34.69 14.46H209.78Zm170-268v-466.44 466.44Z" />
  </svg>
);

export default TerminalIcon;
